/**
 * Secondary sidebar configurations for shell layout.
 * Each config defines a section header + nav items for a product area.
 *
 * Phase 68 M4 extraction D.4
 */

import { APP_KEYS, type AppKey } from './appKeys'

export interface SidebarItem {
  path: string
  label: string
  icon: string // MUI icon name — resolved to component in SecondarySidebar
  requiredApp?: AppKey // Phase 76: App access gating key
  exact?: boolean // When true, only matches the exact path (no prefix matching)
}

export interface SidebarConfig {
  header: {
    icon: string
    label: string
  }
  items: SidebarItem[]
}

export const CANTERA_SIDEBAR: SidebarConfig = {
  header: { icon: 'Work', label: 'Cantera' },
  items: [
    { path: '/talent-pipeline/tablero', label: 'Tablero', icon: 'Dashboard' },
    { path: '/talent-pipeline', label: 'Buscar Candidatos', icon: 'PersonSearch' },
    { path: '/talent-pipeline/upload', label: 'Admin de Talento', icon: 'UploadFile' },
    { path: '/talent-pipeline/positions', label: 'Gestión de Posiciones', icon: 'Assignment' },
    { path: '/talent-pipeline/projects', label: 'Asignaciones', icon: 'Business' },
    { path: '/talent-pipeline/colaboradores', label: 'Colaboradores', icon: 'Badge' },  // Phase 113 (route-level RBAC; no requiredApp per CANTERA convention)
    { path: '/talent-pipeline/clients', label: 'Clientes', icon: 'People' },
  ],
}

export const COMPAS_SIDEBAR: SidebarConfig = {
  header: { icon: 'Explore', label: 'Compás' },  // L2: Compass icon per design lock
  items: [
    { path: '/chat', label: 'Chat', icon: 'Chat' },
    { path: '/knowledge', label: 'Gestión de Documentos', icon: 'LibraryBooks', requiredApp: APP_KEYS.KNOWLEDGE },
  ],
}

export const BANRURAL_SIDEBAR: SidebarConfig = {
  header: { icon: 'AccountBalance', label: 'Banrural' },
  items: [
    { path: '/banrural', label: 'Dashboard', icon: 'Dashboard', exact: true, requiredApp: APP_KEYS.BANRURAL },
    { path: '/banrural/extraccion', label: 'Extracción de Datos', icon: 'UploadFile', requiredApp: APP_KEYS.BANRURAL },
    { path: '/banrural/tipos-credito', label: 'Tipos de Crédito', icon: 'Settings', requiredApp: APP_KEYS.BANRURAL },
    { path: '/banrural/tipos-cuotas', label: 'Tipos de Cuotas', icon: 'CreditCard', requiredApp: APP_KEYS.BANRURAL },
  ],
}

export const ADMIN_SIDEBAR: SidebarConfig = {
  header: { icon: 'Settings', label: 'Administración' },
  items: [
    { path: '/admin/users', label: 'Gestión de Usuarios', icon: 'People', requiredApp: APP_KEYS.USERS },
    { path: '/admin/permisos', label: 'Permisos', icon: 'Shield', requiredApp: APP_KEYS.PERMISOS },  // Phase 70
    { path: '/admin/plataforma', label: 'Plataforma', icon: 'Dashboard', requiredApp: APP_KEYS.PLATAFORMA },
  ],
}
